import styled, { css } from "styled-components";

interface logoProps {
  applyStyle: boolean;
  colour: string;
  sizeVariant?: boolean;
}

export const ApplyBorder = styled.div<logoProps>`
  ${({ applyStyle, colour, sizeVariant }) =>
    applyStyle &&
    css`
  color: rgb(1, 82, 148);
  padding-right:${sizeVariant ? "10px" : "0px"};
  border-right: 1px solid 
    colour === "blue"
      ? rgb(1, 82, 148)
      : rgb(255, 255, 255);
  Alignments: Horizontal;
  Vertical
  `}
`;
